<div class="container">
  <div class="row mx-3 mt-3 mb-4 g-4 justify-content-between">
    <div class="container">
      <div class="row gx-5">
        <!-- Dati Generali -->
        <app-card-dati-generali
          [profileData]="profileData"
          class="col-lg-4 col-sm-12 margin-mobile"></app-card-dati-generali>
        <!-- Card Gamification recap -->
        <app-card-gamification
          class="col-lg-4 col-sm-12 margin-mobile"></app-card-gamification>
        <!-- Card Monitoraggio recap -->
        <app-card-monitoraggio
          class="col-lg-4 col-sm-12"></app-card-monitoraggio>
      </div>
    </div>

    <!-- Hobbies -->
    <app-hobbies [profile_hobby]="profile_hobby" class="col-12"></app-hobbies>
  </div>
</div>
